<template>
  <v-data-table
    v-model="secoes_selecionadas"
    :headers="headers"
    :items="lista_secoes"
    class="elevation-2 font-resp-tabela table-full-screen"
    :fixed-header="true"
    :search="search"
    show-select
    item-key="idsecao"
    height="calc(100vh - 243px)"
    :items-per-page="-1"
  >
    <template #top>
      <div class="d-flex align-center px-3 py-3">
        <v-icon>mdi-format-list-bulleted</v-icon>
        <span class="font-18 font-weight-medium ml-1">Lista de Seções</span>

        <v-spacer />

        <div class="w-400 mr-4">
          <v-text-field
            label="Pesquisar"
            clearable
            v-model="search"
            v-lazy-input:debounce="500"
            hide-details
            dense
            append-icon="mdi-magnify"
          />
        </div>

        <VincularSecoes
          v-model="dialogVinculaComprador"
          :secoes_datadable_selecionada="secoes_selecionadas"
          label="Secoes"
          outlined
          multiple
          hide-details
          @update:secao="buscarListaDeSecoes"
          @dialog-fechado="secoes_selecionadas = []"
        />

      </div>
    </template>

    <template #item.action="{ item }">
      <div class="d-flex align-center">
        <v-btn
          icon
          class="ml-n1"
          title="Editar Usuário"
          @click="editarItem(item)"
          :disabled="item.ativo === 'N'"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { buscarListasDeSecoes } from "@/api/Secoes"
import VincularSecoes from "./VincularSecoes.vue";
import { logout } from "@/helpers";

export default {
  name: "Secao",
  components: {
    VincularSecoes
  },
  data() {
    return {
      dialogVinculaComprador: false,
      search: "",
      lista_secoes: [],
      secoes_selecionadas: [],
      headers: [
        { text: "Id Seção", align: "left", value: "idsecao" },
        { text: "Seção", value: "descricao_secao" },
        { text: "Id Departamento", value: "iddepartamento" },
        { text: "Departamento", value: "descricao_departamento" },
        { text: "Id comprador", value: "idcomprador" },
        { text: "Comprador", value: "descricao_comprador" },
        { text: "Ações", value: "action", sortable: false, width: "100px", align: "center" },
      ]
    };
  },
  created() {
    this.buscarListaDeSecoes();
  },
  methods: {
    abrirDialog(item) {
      let arrayIdFornecedor = this.Helpers.arrayColumn(item, "id");
      let arrayFornecedor = [];
      arrayIdFornecedor.forEach((el) => arrayFornecedor.push(el));
      this.editedItem = arrayFornecedor;
      this.dialogMultiplos = true;
    },
    buscarListaDeSecoes() {
      this.$store.dispatch(
        "loading/addRequisicao",
        buscarListasDeSecoes()
          .then(secoes => {
            this.lista_secoes = secoes;
          })
          .catch(logout)
      );
    },
    editarItem(item) {
      this.secoes_selecionadas = [item];
      this.dialogVinculaComprador = true
    }
  }
}
</script>

<style>

</style>
